// extracted by mini-css-extract-plugin
export var acceptButton = "_3m-6";
export var backdropBlur = "_3m-0";
export var fullContent = "_3m-5";
export var link = "_3m-7";
export var linkIcon = "_3m-8";
export var sideContent = "_3m-4";
export var sideImage = "_3m-3";
export var sideImageWrapper = "_3m-2";
export var splitLayout = "_3m-1";